import type { Photo } from './types';

/**
 * Cropped derivatives are useful on public cards but hide evidence during
 * editorial review. Prefer the dedicated fit derivative for queues and the
 * original derivative when editors ask to inspect a larger image.
 */
export const getModerationPreviewUrl = (photo: Photo): string =>
  photo.imageUrls.smallFit ||
  photo.imageUrls.private ||
  photo.imageUrls.large ||
  photo.imageUrls.gallery ||
  photo.imageUrls.medium ||
  photo.imageUrls.small ||
  photo.imageUrls.thumbnail;

export const getModerationFullUrl = (photo: Photo): string =>
  photo.imageUrls.private ||
  photo.imageUrls.gallery ||
  photo.imageUrls.large ||
  photo.imageUrls.medium ||
  getModerationPreviewUrl(photo);
